import routes from '../../config/routes';
import {X_LANGUAGE_CODE} from '../types';

export const getHeaderLanguageCode = (languageCode?: string | null) => {
  const headers: HeadersInit = {};
  if (languageCode && languageCode.length === 2) {
    headers[X_LANGUAGE_CODE] = languageCode;
  }
  return headers;
};

export const getLanguageCode = (pathname: string) => {
  const matcher = new RegExp(
    `\/(\\w\\w)(${routes.availability}|${routes.reschedule}|\/datetime-ui)`,
  );
  const matchingLang = pathname.match(matcher);
  const languageCode = matchingLang && matchingLang[1].trim();
  return languageCode;
};
